/** The part of a title the hero shows in orange: the first occurrence of `highlight`, or nothing. */
export function splitTitle(title: string, highlight?: string | null): { before: string; match: string; after: string } {
  const needle = highlight?.trim() ?? "";
  const index = needle ? title.indexOf(needle) : -1;
  if (index < 0) return { before: title, match: "", after: "" };
  return { before: title.slice(0, index), match: needle, after: title.slice(index + needle.length) };
}
